<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="col-md-12 mb-5">
        <div class="row">
            <FormDynamic 
            :form_format="form_format"
            :form_data="form_data"
            :array_options="array_options"
            content_align_x="22"
            >
                <template v-slot:more-fields>
                    <div class="formdynamic_item col-md-4 py-o">
                        <div class="formdynamic__item__field">
                            <label class="modal-label input-date-template" v-html="`Date Range:`"/>
                            <date-range-picker
                            class="d-block"
                            ref="picker"
                            v-model="form_data.date_range"
                            cancelLabel="Clear">
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                                </template>

                                <div slot="footer" slot-scope="data" class="slot p-2">
                                    <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                                    {{ data.rangeText }}
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                                    </span>
                                </div>
                            </date-range-picker>
                        </div>
                    </div>
                </template>
            </FormDynamic>
        </div>
        <div class="formdynamic_item col-md-4 py-o">
            <button  class="modal__buttons__item w-auto px-3 ml-0" @click="getReport()">Download Report</button>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

  
  
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import FormDynamic  from '@/components/FormDynamic.vue'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "RoomTypeByBuildingReport",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        DateRangePicker,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            parent_id: 33,
            staffing_scenario_id: this.$route.params.id,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Supervisor Inspection Completion Report By Template',
            current_url: `/reports`,
            table_headers: [],
            array_options: {
                building_id: [],
                level_id: [],
                area_id: [],
                template_id: []
            },
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            search: '',
            first_request: true,
            pdfSource: '',
            form_format: FormResources.form_format_supervisor_inspection_completion_by_template,
            form_data:  FormResources.form_data_supervisor_inspection_completion_by_template,
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        clearRangeDate(data)
        {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) 
        {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        async getReport()
        {
            if(this.form_data.date_range.startDate === null || this.form_data.date_range.endDate === null)
            {
                this.notyf.error('Please select a date range')
                return
            }

            const form_data = {
                standard_report_id: 33,
                params: this.form_data
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) 
            {
                await this.downloadFile(response)
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)
        },
        async getInitialData(first_request = true)
        {
            const form_data = {
                module_id: this.parent_id,
                first_request: first_request, 
                building_id: this.form_data.building_id,
                level_id: this.form_data.level_id,
            }

            this.loader(true)

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) 
            {
               if (first_request) 
               {
                    this.array_options = {
                        building_id: response.data.building_id || [],
                        level_id: response.data.level_id || [],
                        area_id: response.data.area_id || [],
                        template_id: response.data.template_id || [],
                    }
                } 
                else 
                {
                    this.array_options.level_id = response.data.level_id || [];
                    this.array_options.area_id = response.data.area_id || [];
                }
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)

            return response.data
        },

    },

    watch: {
        'form_data.building_id': function() {
            this.getInitialData(false);
            this.form_data.level_id = [];
        },
        'form_data.level_id': function() {
            this.getInitialData(false);
            this.form_data.area_id = [];
        }
    },

    async mounted() 
    {
        if (this.hasPermissions(['Report Read'])) 
        {
            this.getInitialData()

            const today = moment();
            const startDate = today.clone().day(0).format('YYYY-MM-DD') + "T23:00:00.000Z";
            const endDate = today.clone().day(6).format('YYYY-MM-DD') + "T23:59:59.999Z";

            this.form_data.date_range = {startDate: startDate, endDate: endDate}

            this.breadcrumb.push(
                {
                    name: 'Supervisor Inspection Completion Report By Template',
                    href: 'supervisor-inspection-completion-report-by-template',
                    arrow: '',
                },
            )
        }
    },

}
</script>
